import list from './list'
import imp from './imp'
import replace from './replace'
import receipt from './receipt'
import dzd from './dzd'
import receiptOrder from './receiptOrder'
import importOrder from './importOrder'
export default {
  list,
  imp,
  replace,
  receipt,
  dzd,
  receiptOrder,
  importOrder
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/index.js